"use client";
// Import modules
import Image from "next/image";
import { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

// Import assets
import NextLogo from "@/assets/images/right-arrow.svg";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const Privacy = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfWidth, setPdfWidth] = useState(800);
  const [pdfHeight, setPdfHeight] = useState(1200);

  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth) {
      const width = window.innerWidth - 50 > 800 ? 800 : window.innerWidth - 50;
      setPdfWidth(width);
      setPdfHeight(width * 1.5);
    }
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div className="wrap">
      <p className="pdf-heading">
        Page {pageNumber} of {numPages}
      </p>

      <div className="controls">
        <button
          disabled={pageNumber === 1}
          onClick={() => {
            setPageNumber(pageNumber - 1);
          }}
        >
          <Image className="prev" src={NextLogo} alt="prev-logo" />
        </button>

        <button
          disabled={pageNumber === numPages}
          onClick={() => {
            setPageNumber(pageNumber + 1);
          }}
        >
          <Image className="next" src={NextLogo} alt="next-logo" />
        </button>
      </div>

      <Document
        file={{
          url: "https://triotech-website.s3.ap-south-1.amazonaws.com/public/LEA%20Reporting%20Policy%20Feb.pdf",
        }}
        options={{
          cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
          cMapPacked: true,
        }}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        <Page pageNumber={pageNumber} height={pdfHeight} width={pdfWidth} />
      </Document>
    </div>
  );
};

export default Privacy;
